// Core
import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';

// Chakra
import {
  Text,
  useColorModeValue,
  Divider,
  Button,
  Flex,
  Table,
  Thead,
  Tr,
  Td,
  Tbody,
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import NotFound from 'views/Dashboard/404.js';
import Pagination from '../../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa6';
import Card from '../../../components/Card/Card';
import TableSkeleton from '../../../components/TableSkeleton';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

const Station = () => {
  const history = useHistory();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const textColor = useColorModeValue('gray.700', 'white');
  const paddingTd = '16px 0 16px 24px';
  const [offset, setOffset] = useState(0);
  const [stations, setStations] = useState([]);
  const [stationsMeta, setStationsMeta] = useState([]);
  const limit = 25;

  const isStations = usePermissionStatusByKey('GET:/admin/stations');

  const { isFetching, refetch } = useQuery({
    queryKey: ['stations', offset, isStations],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      if (isStations) {
        const params = {
          limit,
          offset,
        };

        const response = await apiService.getStations(params);
        setStations(response.data);
        setStationsMeta(response.meta);
      }

      return true;
    },
    retry: false,
    refetchInterval: 30000,
  });

  const onNewButtonClicked = useCallback(() => {
    history.push('/stations/new');
  }, [history]);

  const handleEditOpen = useCallback(
    (plan) => {
      history.push(`/stations/${plan.id}`);
    },
    [history],
  );

  const handleDelete = useCallback(
    async (item) => {
      await apiService.deleteStation(item);
      refetch();
    },
    [refetch],
  );

  const isStation = usePermissionStatusByKey('GET:/admin/stations/:id');
  const isCreateStations = usePermissionStatusByKey('POST:/admin/stations');

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Text
          fontSize="40px"
          fontStyle="normal"
          fontWeight="700"
          color={textColor}
          mb="0px"
          className="page-name"
        >
          Stations
        </Text>

        {isCreateStations && (
          <Button
            variant="submit-ms"
            maxW="140px"
            w="100%"
            onClick={onNewButtonClicked}
            leftIcon={<FaPlus />}
          >
            Create
          </Button>
        )}
      </Flex>

      <Divider
        opacity="1"
        mr="2px"
        borderColor={borderColor}
        borderTopWidth="1px"
        borderBottomWidth="0"
        mb="32px"
      />

      {isStations && (
        <>
          {isFetching ? (
            <TableSkeleton rowCount={5} />
          ) : stations.length > 0 ? (
            <Card padding={'8px'}>
              <Table color={textColor}>
                <Thead>
                  <Tr>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Name
                      </Text>
                    </Td>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        External ID
                      </Text>
                    </Td>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Phone
                      </Text>
                    </Td>
                    <Td>
                      <Text variant="title-md" p="0 0 6px 0">
                        Location Address
                      </Text>
                    </Td>
                  </Tr>
                </Thead>
                <Tbody>
                  {stations.map((row) => {
                    return (
                      <Tr
                        onClick={() => {
                          if (isStation) {
                            handleEditOpen(row);
                          }
                        }}
                        _last={{
                          '& td': {
                            borderBottom: 'none !important',
                          },
                        }}
                        key={row.id}
                        border="unset"
                        className="cursor-tr"
                      >
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.name}
                          </Text>
                        </Td>
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.externalId}
                          </Text>
                        </Td>
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.phone}
                          </Text>
                        </Td>
                        <Td verticalAlign="center" p={paddingTd}>
                          <Text variant="text" color={textColor}>
                            {row?.locationAddress}
                          </Text>
                        </Td>
                        {/*<Td verticalAlign="center" p={paddingTd}>*/}
                        {/*  <DeleteIcon color="#DE3730" fontSize="24px" />*/}
                        {/*</Td>*/}
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </Card>
          ) : (
            <NotFound text="Not Found" />
          )}

          <Pagination
            meta={stationsMeta ?? { limit, offset, total: 0 }}
            isLoadingPage={isFetching}
            currentPage={Math.floor(offset / limit) + 1}
            onPageChange={(newOffset) => setOffset(newOffset)}
          />
        </>
      )}

      {/*<Attention*/}
      {/*  variant="remove"*/}
      {/*  handle={() => handleDelete(object)}*/}
      {/*  isOpen={isOpen}*/}
      {/*  onOpen={onOpen}*/}
      {/*  onClose={onClose}*/}
      {/*/>*/}
    </>
  );
};

export default Station;
